import { render } from "./ComponentTextSetting.vue?vue&type=template&id=7bad9c52&scoped=true"
import script from "./ComponentTextSetting.vue?vue&type=script&lang=js"
export * from "./ComponentTextSetting.vue?vue&type=script&lang=js"

import "./ComponentTextSetting.vue?vue&type=style&index=0&id=7bad9c52&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bad9c52"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/ComponentTextSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7bad9c52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7bad9c52', __exports__)) {
    api.reload('7bad9c52', __exports__)
  }
  
  module.hot.accept("./ComponentTextSetting.vue?vue&type=template&id=7bad9c52&scoped=true", () => {
    api.rerender('7bad9c52', render)
  })

}


export default __exports__